import React, { useEffect, useRef } from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const AgendaFormFilterCats = ({OnChangeFilterCats, AgendaFilterActiveOther}) => {
	const selectRef = useRef(null)
	// Validation des props et gestion des erreurs
	if (typeof OnChangeFilterCats !== 'function') {
		return (
			<div role="region" aria-label="Filtre de catégories d'événements" className="agenda-form-filter-cats-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : fonction de changement de filtre manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Validation des données de sélection
	if (!SELECTS || !SELECTS['others'] || !Array.isArray(SELECTS['others'])) {
		return (
			<div role="region" aria-label="Filtre de catégories d'événements" className="agenda-form-filter-cats-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : données de catégories manquantes ou invalides</p>
				</div>
			</div>
		)
	}

	// Construction de l'aria-label pour le composant Select
	const selectLabel = "Sélectionner le type d'événement"
	const selectDescription = "Filtre pour sélectionner le type d'événement à afficher dans l'agenda"

	// Effet pour ajouter le rôle listbox au conteneur des options
	useEffect(() => {
		const updateSelectAccessibility = () => {
			if (typeof window === 'undefined' || !selectRef.current) return

			// Trouver le conteneur du menu des options de react-select
			// react-select crée une structure avec .Select-menu-outer contenant .Select-menu
			// Le menu peut être dans le conteneur ou dans document.body (portail)
			const menuContainer = document.querySelector('#react-select-2--value .Select-value')

			if (menuContainer) {
				// Ajouter le rôle listbox au conteneur des options
				menuContainer.setAttribute('role', 'listbox')
				menuContainer.setAttribute('id', 'agenda-filters-category-listbox')
				menuContainer.setAttribute('aria-label', 'Tous les types d\'événements')
				
				// S'assurer que les options ont le bon rôle
				const options = menuContainer.querySelectorAll('.Select-option')
				options.forEach((option, index) => {
					if (!option.hasAttribute('role')) {
						option.setAttribute('role', 'option')
					}
					if (!option.hasAttribute('id')) {
						option.setAttribute('id', `agenda-filters-category-option-${index}`)
					}
				})
			}

			// Trouver le contrôle principal (combobox)
			const control = selectRef.current.querySelector('.Select-control')
			if (control) {
				const input = control.querySelector('input')
				if (input) {
					// Ajouter aria-owns pour lier le combobox au listbox
					input.setAttribute('aria-owns', 'agenda-filters-category-listbox')
					input.setAttribute('aria-haspopup', 'listbox')
					if (!input.hasAttribute('role')) {
						input.setAttribute('role', 'combobox')
					}
				}
			}
		}

		// Mettre à jour immédiatement
		updateSelectAccessibility()

		// Observer les changements du DOM pour mettre à jour quand le menu s'ouvre
		// Observer à la fois le conteneur et document.body (au cas où le menu est rendu en portail)
		const observer = new MutationObserver(() => {
			setTimeout(updateSelectAccessibility, 50)
		})
		
		if (selectRef.current) {
			observer.observe(selectRef.current, {
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: ['class']
			})
		}

		// Observer aussi document.body au cas où le menu est rendu en portail
		const bodyObserver = new MutationObserver(() => {
			setTimeout(updateSelectAccessibility, 50)
		})
		
		bodyObserver.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'role']
		})

		// Écouter les événements de clic et de focus pour mettre à jour quand le menu s'ouvre
		const handleInteraction = () => {
			setTimeout(updateSelectAccessibility, 100)
		}

		if (selectRef.current) {
			selectRef.current.addEventListener('click', handleInteraction)
			selectRef.current.addEventListener('focus', handleInteraction, true)
		}

		return () => {
			observer.disconnect()
			bodyObserver.disconnect()
			if (selectRef.current) {
				selectRef.current.removeEventListener('click', handleInteraction)
				selectRef.current.removeEventListener('focus', handleInteraction, true)
			}
		}
	}, [AgendaFilterActiveOther])

	return (
		<div role="group" aria-label="Filtre de catégories d'événements" className="agenda-form-filter-cats-container">
			<label htmlFor="agenda-filters-category" className="agenda-form-filter-cats-label visually-hidden">
				{selectLabel}
			</label>
			
			<div ref={selectRef}>
				<Select 
					id="agenda-filters-category"
					className="generic-filters-select generic-filters-select-category agenda-filters-select agenda-filters-select-category" 
					name="agenda-filters-category" 
					placeholder="Tous les types d'évènements" 
					options={SELECTS['others']} 
					onChange={OnChangeFilterCats}
					value={AgendaFilterActiveOther}
					simpleValue
					clearable={false}
					searchable={false}
					aria-label={selectLabel}
					aria-describedby="agenda-form-filter-cats-description"
				/>
			</div>
			
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="agenda-form-filter-cats-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				{selectDescription}
			</div>

			{/* Message de statut pour les lecteurs d'écran */}
			<div 
				className="visually-hidden" 
				aria-live="polite" 
				aria-label="Statut du filtre de catégories"
			>
				Filtre de catégories chargé avec succès
			</div>
		</div>
	)
}

export default AgendaFormFilterCats
